import { render, staticRenderFns } from "./StudentTeaser.vue?vue&type=template&id=19e8a784&scoped=true&"
import script from "./StudentTeaser.vue?vue&type=script&lang=js&"
export * from "./StudentTeaser.vue?vue&type=script&lang=js&"
import style0 from "./StudentTeaser.vue?vue&type=style&index=0&id=19e8a784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e8a784",
  null
  
)

export default component.exports